export const changeOverflowForRootElem = (hidden/* , pathname */, currentPathname) => {
    if (hidden /* || pathname === currentPathname */) document.querySelector(':root').style.overflowY = 'hidden';
    else document.querySelector(':root').style.overflowY = 'auto';
};